import { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "";
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    if (!email) { toast.error("Session missing — try signing up again"); return; }
    setLoading(true);
    try {
      await api.post("/auth/verify-email", { email, otp: otp.trim() });
      toast.success("Email verified!");
      navigate("/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 p-8 text-center shadow-sm">
        <div className="w-14 h-14 mx-auto rounded-full bg-teal-100 text-teal-700 flex items-center justify-center">
          <MailCheck className="w-7 h-7" />
        </div>
        <h1 className="font-heading text-2xl font-extrabold mt-4 text-slate-900">Verify your email</h1>
        <p className="text-sm text-slate-600 mt-2">We've emailed a 6-digit code to <strong>{email || "your email"}</strong>. Enter it below to activate your account.</p>

        <Input data-testid="verify-otp" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))} maxLength={6} className="mt-5 text-center text-2xl font-mono tracking-widest" placeholder="000000" />

        <Button data-testid="verify-submit" onClick={verify} disabled={loading || otp.length !== 6} className="mt-4 w-full h-11 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-semibold">
          {loading ? "Verifying..." : "Verify email"}
        </Button>

        <p className="mt-4 text-xs text-slate-500">
          Can't find it? Check spam, or <Link to="/dashboard" className="font-semibold text-teal-700">skip for now</Link>.
        </p>
      </div>
    </div>
  );
}
